import { render, staticRenderFns } from "./New-Lead-Card-Slot.vue?vue&type=template&id=9a1f7f92"
import script from "./New-Lead-Card-Slot.vue?vue&type=script&lang=js"
export * from "./New-Lead-Card-Slot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports